import { render, staticRenderFns } from "./SharePage.vue?vue&type=template&id=7351cd6a&scoped=true&"
import script from "./SharePage.vue?vue&type=script&lang=js&"
export * from "./SharePage.vue?vue&type=script&lang=js&"
import style0 from "./SharePage.vue?vue&type=style&index=0&id=7351cd6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7351cd6a",
  null
  
)

export default component.exports